// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tbl-type03 tbody td{height:70px !important;\n}\n.treeBox{height:570px}\n", ""]);
// Exports
module.exports = exports;
